var map = {
	"./InstantBookingSpinner": 642,
	"./InstantBookingSpinner.js": 642,
	"./InstantBookingSpinner.scss": 2015,
	"./contract.svg": 2016,
	"./handshake.svg": 2017,
	"./headphones.svg": 2018,
	"./leftArrow.svg": 643,
	"./logo.svg": 2019,
	"./money.svg": 644,
	"./package": 645,
	"./package.json": 645,
	"./rightArrow.svg": 646,
	"./shield.svg": 647,
	"./spinner.svg": 648,
	"./trucks.svg": 649
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 668;



//////////////////
// WEBPACK FOOTER
// ./client/components/InstantBookingSpinner ./~/svg-inline-loader!^\.\/.*$
// module id = 668
// module chunks = 0